import { values } from './_helpers'

const _enum = {
  created: 0,
  sent: 1,
  didNotArrive: 2,
  partiallyArrived: 3,
  arrived: 4
}

const orderStatus = { ..._enum, name: 'orderStatus', values: values(_enum) }

export {
  orderStatus
}
